import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { dataverseService } from '../services/dataverseService';

const BlaalysModeContext = createContext({
  allowBlaalysOverride: false,
  loading: true,
  error: null,
  refresh: async () => {},
  setAllowBlaalysOverride: async () => {}
});

export const useBlaalysMode = () => useContext(BlaalysModeContext);

export function BlaalysModeProvider({ children }) {
  const [allowBlaalysOverride, setFlag] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const settings = await dataverseService.operationsSettingsService.get();
      setFlag(Boolean(settings?.allowBlaalysOverride));
    } catch (loadError) {
      console.warn('Blaalys mode load failed:', loadError);
      setError(loadError);
      setFlag(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const setAllowBlaalysOverride = useCallback(async (enabled) => {
    const updated = await dataverseService.operationsSettingsService.setAllowBlaalysOverride(enabled);
    setFlag(Boolean(updated?.allowBlaalysOverride));
    return updated;
  }, []);

  const value = useMemo(
    () => ({
      allowBlaalysOverride,
      loading,
      error,
      refresh,
      setAllowBlaalysOverride
    }),
    [allowBlaalysOverride, loading, error, refresh, setAllowBlaalysOverride]
  );

  return <BlaalysModeContext.Provider value={value}>{children}</BlaalysModeContext.Provider>;
}
